const SvgPolicyIcon = ({ color }) => (
  <svg width={24} height={24} fill="none">
    <g fill={color} clipPath="url(#policyIcon_svg__a)">
      <path d="M18 24c-.1 0-.2-.02-.294-.06-.232-.099-5.706-2.483-5.706-7.386v-4.018a.75.75 0 0 1 .509-.71l5.25-1.786a.75.75 0 0 1 .482 0l5.25 1.786a.75.75 0 0 1 .509.71v4.018c0 4.903-5.474 7.287-5.706 7.387A.767.767 0 0 1 18 24Zm-4.5-10.927v3.48c0 3.333 3.456 5.337 4.5 5.865 1.044-.528 4.5-2.532 4.5-5.865v-3.48L18 11.542l-4.5 1.531Z" />
      <path d="M17.75 19.5a.746.746 0 0 1-.53-.22l-2-2a.75.75 0 0 1 1.061-1.061l1.389 1.389 2.48-3.308a.75.75 0 1 1 1.199.901l-3 4a.75.75 0 0 1-.547.298l-.052.001ZM10.59 21H2.75A2.752 2.752 0 0 1 0 18.25V2.75A2.752 2.752 0 0 1 2.75 0h11.5A2.752 2.752 0 0 1 17 2.75v5.43a.75.75 0 1 1-1.5 0V2.75c0-.689-.561-1.25-1.25-1.25H2.75c-.689 0-1.25.561-1.25 1.25v15.5c0 .689.561 1.25 1.25 1.25h7.84a.75.75 0 1 1 0 1.5Z" />
      <path d="M13.25 9.5h-9.5a.75.75 0 0 1 0-1.5h9.5a.75.75 0 1 1 0 1.5Zm-4 4h-5.5a.75.75 0 1 1 0-1.5h5.5a.75.75 0 1 1 0 1.5Zm-1-8h-4.5a.75.75 0 0 1 0-1.5h4.5a.75.75 0 0 1 0 1.5Z" />
    </g>
    <defs>
      <clipPath id="policyIcon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPolicyIcon;
